<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <h5 class="text-center">{{ lang.label }} Section</h5>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <fg-input type="text"
                    label="Name"
                    name="name"
                    fou
                    v-model="formData.name">
          </fg-input>
          <fg-input type="text"
                    label="Main Heading"
                    name="main_heading"
                    fou
                    v-model="formData.main_heading">
          </fg-input>
          <fg-input type="text"
                    label="Title"
                    name="title"
                    fou
                    v-model="formData.title">
          </fg-input>
          <div class="form-group">
            <label>Content</label>
            <editor
              v-model="formData.content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>
          <fg-input type="text"
                    label="Destination Url Title"
                    name="destination_url_title"
                    fou
                    v-model="formData.destination_url_title">
          </fg-input>
        </div>
        <label>List Items</label>
        <div class="col-12">
          <template class="row" v-for="(listItem,listItemIndex) in formData.list_items">
            <fg-input type="text"
                      :key="listItemIndex"
                      :label="'Item '+(listItemIndex+1)"
                      v-model="formData.list_items[listItemIndex]">
            </fg-input>
            <div class="col-sm-1 align-self-center mt-3">
              <l-button
                @click="removeItem(formData.list_items, listItemIndex)"
                type="danger" size="sm">
                <i class="fa fa-trash"></i>
              </l-button>
            </div>
          </template>
          <l-button
            class="mt-3"
            type="success"
            @click="addNewItem(formData.list_items)"
            size="sm">
            <i class="fa fa-plus"></i>
          </l-button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import { extend } from "vee-validate";
  import { required, email, regex } from "vee-validate/dist/rules";
  import Editor from '@tinymce/tinymce-vue'
  import FormGroupTextArea from "@/components";

  extend("required", required);
  extend("email", email);
  extend("regex", regex);

  export default {
    components: {
      FormGroupTextArea,
      [Select.name]: Select,
      [Option.name]: Option,
      'editor': Editor
    },
    props: {
      lang: {
        type: Object
      },
      editMode: {
        type: Boolean,
        default: false
      },
      isSubmit: {
        type: Boolean,
        default: false
      },
      formData:{
        type: Object,
        default() {
          return {
            name: "",
            main_heading: "",
            content: "",
            destination_url_title: "",
            title: "",
            list_items: [],
          }
        }
      },
    },
    data () {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang.value, this.isSubmit)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
      addNewItem(listItems) {
        listItems.push('');
      },
      removeItem(listItems, index) {
        listItems.splice(index, 1);
      },
    }
  }
</script>
<style>
</style>
